import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./forgotpassword.scss";
import { TextField } from '@mui/material';

function ForgotPassword() {
    const navigate = useNavigate()
    const [email, setEmail] = useState("");
    
    const isInValidEmail = (value) => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      // Check if the value matches email pattern
      if (emailPattern.test(value)) {
        return false;
      } else {
        return true;
      }
    };
    

    // const submit = async () => {
    //   let emalval = new RegExp(
    //     '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
    //   );
    //     Swal.fire({
    //         html: `<img src="./loader.gif" style="width: 50px" alt="loader">`,
    //         showConfirmButton: false,
    //         heightAuto: false,
    //         customClass: { popup: 'loader-swal' }
    //     });
    //     if (!email) {
    //         Swal.fire({
    //             text: 'Please enter your email.',
    //             icon: 'warning',
    //             showConfirmButton: false,
    //             heightAuto: false,
    //             timer: 1500
    //         });
    //     } else if (email && !emalval.test(email)) {
    //           Swal.fire({
    //             text: 'Please enter valid Email',
    //             icon: 'warning',
    //             showConfirmButton: false,
    //             heightAuto: false,
    //             timer: 1500,
    //           });
    //         } else if (email.length > 255) {
    //           Swal.fire({
    //             text: 'Email should be less than 255 characters',
    //             icon: 'warning',
    //             showConfirmButton: false,
    //             heightAuto: false,
    //             timer: 1500,
    //           });
    //         } else {
    //       let resData = await forgotPassword({ email: email });
    //       if (resData.status === "S") {
    //           Swal.close();
    //           localStorage.setItem('correl_id', resData.correl_id);
    //           navigate("/otp-page");
              
            
            
    //       } else if (resData.status === "E" && resData.result_code === 404) {
    //         Swal.fire({
    //           text: "Invalid Email",
    //           showConfirmButton: false,
    //           icon: "warning",
    //           timer: 3000,
    //         });
    //         return;
    //       } else {
    //         Swal.fire({
    //           text: JSON.stringify(resData),
    //           showConfirmButton: false,
    //           icon: "warning",
    //           timer: 3000,
    //         });
    //         return;
    //       }
    //     }
    // }

    return (
      <div className="loginContainer forgot-screen">
        <div className="row g-0 h-100 w-100">
          <div className="col-6">
            <div className="loginLeft d-none d-lg-flex">
              <h5 className="headingText">
                <strong>Welcome to UpwardIQ!</strong>
              </h5>
              <img
                src={require("../../assets/image.png")}
                alt="RECUPE"
                className="vec-image"
              />
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat eius sint officia laboriosam perferendis omnis nulla incidunt animi nobis tempora!
              </p>
            </div>
          </div>
          <div className="col-12 col-lg-6 h-100">
            <div className="loginRight h-100">
              <h5 className="loginText text-white">Forgot Password</h5>
              <p className="text-white forgot-subtext">Enter your Registered Email</p>
              <TextField
                id="outlined-basic"
                label="Email "
                variant="outlined"
                className="mb-3 cust-white-input-field w-100 "
                autoComplete="off"
                inputProps={{
                  maxLength: 255,
                }}
                value={email}
                onChange={(ev) => {
                  const input = ev.target.value;
                  // Regular expression to block specific patterns
                  const disallowedPattern =
                    /<script.*?>.*?<\/script>|<.*?>|[<>/:?[\]\\|""'',; ]/i;

                  // Allow input only if it doesn't match the pattern
                  if (!disallowedPattern.test(input)) {
                    setEmail(input);
                  }
                }}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    // submit();
                  }
                }}
              />
              {email && isInValidEmail(email) && (
                <span className="text-white text-start">
                  Please enter a valid email.
                </span>
              )}
              <div className="text-center">
                <button
                  className="btn btn-white rounded-pill text-uppercase"
                  onClick={() => {
                    // submit();
                  }}
                >
                  Send
                </button>
              </div>
              <div className="text-center mt-3 text-white">
                <p>
                  Remember password ?{" "}
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    Login
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default ForgotPassword
